import { getPlatformType, PlatformType } from '@nibfe/mkt-env-api';
export const POS_ICON = 'https://p0.meituan.net/ingee/3e7a4e710977e060d291ec8be169870a461.png';
export const POS_ICON_GREY = 'https://img.meituan.net/superseckillmaker/21b132f12a41a5f8b4b46c7c6814ee261084.png';
export const MORE_ICON = 'https://p0.meituan.net/ingee/d5699b1b3d4e312ca9f445774db5d1c9468.png';
export const CARD_MC = 'b_travel_qpdm3cc3_mc';
export const CARD_MV = 'b_travel_qpdm3cc3_mv';
export const MORE_MC = 'b_travel_ueosxb1b_mc';
export const MORE_MV = 'b_travel_ueosxb1b_mv';
// ui稿：https://ingee.meituan.com/#/artboard/1122335/default?action=developer
// 双列
export const skData = '{"type":"Buffer","data":[1,1,119,1,70,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,12,0,9,0,171,1,4,10,255,255,255,255,0,22,0,182,0,146,0,11,0,255,244,244,244,0,22,0,143,0,103,0,14,0,255,244,244,244,0,22,0,163,0,151,0,14,0,255,244,244,244,0,22,0,224,0,58,0,17,0,255,244,244,244,0,21,0,247,0,31,0,10,0,255,244,244,244,0,121,0,227,0,52,0,30,0,255,244,244,244,0,22,0,200,0,31,0,17,0,255,244,244,244,0,61,0,207,0,31,0,10,0,255,244,244,244,0,192,1,22,0,171,1,4,10,255,255,255,255,0,202,1,195,0,146,0,11,0,255,244,244,244,0,202,1,156,0,103,0,14,0,255,244,244,244,0,202,1,176,0,151,0,14,0,255,244,244,244,0,202,1,237,0,58,0,17,0,255,244,244,244,0,202,2,4,0,31,0,10,0,255,244,244,244,1,46,1,240,0,52,0,30,0,255,244,244,244,0,202,1,213,0,31,0,17,0,255,244,244,244,0,241,1,220,0,31,0,10,0,255,244,244,244,0,12,1,22,0,171,1,4,10,255,255,255,255,0,22,1,195,0,146,0,11,0,255,244,244,244,0,22,1,156,0,103,0,14,0,255,244,244,244,0,22,1,176,0,151,0,14,0,255,244,244,244,0,22,1,237,0,58,0,17,0,255,244,244,244,0,21,2,4,0,31,0,10,0,255,244,244,244,0,121,1,240,0,52,0,30,0,255,244,244,244,0,22,1,213,0,31,0,17,0,255,244,244,244,0,61,1,220,0,31,0,10,0,255,244,244,244,0,192,0,9,0,171,1,4,10,255,255,255,255,0,202,0,182,0,146,0,11,0,255,244,244,244,0,202,0,143,0,103,0,14,0,255,244,244,244,0,202,0,163,0,151,0,14,0,255,244,244,244,0,202,0,224,0,58,0,17,0,255,244,244,244,0,202,0,247,0,31,0,10,0,255,244,244,244,1,46,0,227,0,52,0,30,0,255,244,244,244,0,202,0,200,0,31,0,17,0,255,244,244,244,0,241,0,207,0,31,0,10,0,255,244,244,244]}';
export const threeSkBlock = [{
        w: 226,
        h: 170,
        t: 0,
        l: 0,
        brtl: 18,
        brtr: 18,
        brbl: 0,
        brbr: 0
    }, {
        w: 202,
        h: 62,
        t: 178,
        l: 12,
        brtl: 6,
        brtr: 6,
        brbl: 6,
        brbr: 6
    }, {
        w: 70,
        h: 30,
        t: 248,
        l: 12,
        brtl: 6,
        brtr: 6,
        brbl: 6,
        brbr: 6
    }, {
        w: 70,
        h: 30,
        t: 248,
        l: 88,
        brtl: 6,
        brtr: 6,
        brbl: 6,
        brbr: 6
    }, {
        w: 113,
        h: 30,
        t: 294,
        l: 12,
        brtl: 6,
        brtr: 6,
        brbl: 6,
        brbr: 6
    }, {
        w: 70,
        h: 18,
        t: 328,
        l: 12,
        brtl: 6,
        brtr: 6,
        brbl: 6,
        brbr: 6
    }, {
        w: 84,
        h: 50,
        t: 294,
        l: 130,
        brtl: 12,
        brtr: 12,
        brbl: 12,
        brbr: 12
    }];
const platformType = getPlatformType();
export const IS_MT_WEB = platformType === PlatformType.mtAppWebView;
